import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as projectApi from '../../lib/api/project';
import { firstDayofYear, lastDayofYear } from '../../utils/calcDatetime';

const [
  LIST_ETC_PROJECTS,
  LIST_ETC_PROJECTS_SUCCESS,
  LIST_ETC_PROJECTS_FAILURE,
] = createRequestActionTypes('project/LIST_ETC_PROJECTS');

export const listEtcProjects = createAction(
  LIST_ETC_PROJECTS,
  (searchData) => searchData,
);
const listEtcProjectsSaga = createRequestSaga(
  LIST_ETC_PROJECTS,
  projectApi.getEtcProjects,
);

const UNLOAD_ETC_PROJECTS = 'project/UNLOAD_ETC_PROJECTS';
export const unloadEtcProjects = createAction(UNLOAD_ETC_PROJECTS);

const SET_ETC_PROJECT_FILTERS = 'project/SET_ETC_PROJECT_FILTERS';
export const setEtcProjectFilter = createAction(
  SET_ETC_PROJECT_FILTERS,
  (filters) => filters,
);

const RESET_ETC_PROJECT_FILTERS = 'project/RESET_ETC_PROJECT_FILTERS';
export const resetEtcProjectFilters = createAction(RESET_ETC_PROJECT_FILTERS);

export function* etcProjectsSaga() {
  yield takeLatest(LIST_ETC_PROJECTS, listEtcProjectsSaga);
}

const initialState = {
  totals: null,
  projects: null,
  error: null,
  defaultFilters: {
    searchGrade: '',
    searchPrjImpt: '',
    searchKeyword: 'cstNm',
    searchWords: '',
    searchStrtDt: firstDayofYear,
    searchEndDt: lastDayofYear,
  },
};

const etcProjects = handleActions(
  {
    [LIST_ETC_PROJECTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totals: data.totals,
      projects: data.list.map((project) => ({
        id: project.prjUuid,
        prjUuid: project.prjUuid,
        prjSeq: project.prjSeq,
        prjNo: project.prjNo,
        prjTyp: project.prjTyp,
        expDay: project.expDay,
        bookingDay: project.bookingDay,
        cstStatus: project.cstStatus,
        cstGrade: project.cstGrade,
        cmpGrade: project.cmpGrade, //1/2/3/4
        cmpStatus: project.cmpStatus, //착수보고/분석설계/구축(이행)/완료(검수)
        cstNm: project.cstNm, //프로젝트명
        vendorCmpNm: project.vendorCmpNm, //매출처명
        clientCmpNm: project.clientCmpNm, //매출처명
        totalPurchase: project?.totalPurchase,
        totalSales: project?.totalSales,
        totalProfit: project?.totalProfit,
        useYn: project.useYn,
        ordYn: project.ordYn,
        crtDptNm: project.crtDptNm,
        crtNm: project.crtNm,
        crtGradeNm: project.crtGradeNm,
        crtDt: project.crtDt,
        cngNm: project.cngNm,
        cngDt: project.cngDt,
      })),
      error: null,
    }),
    [LIST_ETC_PROJECTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_ETC_PROJECTS]: () => initialState,
    [RESET_ETC_PROJECT_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_ETC_PROJECT_FILTERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default etcProjects;
